import { configureStore, combineReducers, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// ----------------------------------------------------------------Reducers
import authReducer from './slices/Auth.slice';
import dashReducer from './slices/Dashboard.slice';
import decisionReducer from './slices/Decision.Slice';
import videoReducer from './slices/Video.slice';
import utilReducer from './slices/Util.slice';
import categoryReducer from './slices/Categories.slice';
import antibioticReducer from './slices/Antibiotic.slice';
import chapterReducer from './slices/Chapter.slice';
import overviewReducer from './slices/Overview.slice';

// ----------------------------------------------------------------Config

const persistConfig = {
  key: 'root',
  storage
};

const reducer = {
  auth: authReducer,
  dashboard: dashReducer,
  decision: decisionReducer,
  video: videoReducer,
  util: utilReducer,
  category: categoryReducer,
  antibiotic: antibioticReducer,
  chapter: chapterReducer,
  overview: overviewReducer
};

const persistedReducer = persistReducer(persistConfig, combineReducers({ ...reducer }));

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: getDefaultMiddleware({
    serializableCheck: false
  })
});

export const persistor = persistStore(store);
